import * as _ from 'underscore';
import { ListProperty } from './listProperty';
import { Event } from './event';
import { RecursiveDataSource } from './data';
import { SortOptions, RecursiveListOptions } from '../interfaces/options';
import { IEvent, IRecursiveDataEntry } from '../interfaces';
import { SelectionMode, SortState } from '../enums';
import { IconSet } from '../const';
import { Localization } from '../compile';
import { DefaultRecursiveListOptions } from '../const/defaultOptions';
//import * as jqui from 'jquery-ui-dist'
import 'knockout-sortable';
import { RecursiveDataChangedEvent } from 'mappMvc/events';
import { Util } from 'mappMvc/models';

export enum RecursiveListSelectionState {
	NONE,
	SUBSET,
	ALL
}

export class RecursiveList {
	public dataSource: RecursiveDataSource;
	public idProperty: string;
	protected options: RecursiveListOptions;
	public view: KnockoutComputed<IRecursiveDataEntry[]>;
	protected properties: ListProperty[];
	private clickOnProperty: (property: ListProperty) => void;
	private sortSettingStack: {
		[key: string]: SortOptions;
	};

	public isEmpty: KnockoutComputed<boolean>;
	public viewIsEmpty: KnockoutComputed<boolean>;
	public itemsCountInfo: KnockoutComputed<string>;

	//selection
	private _selectedItems: KnockoutObservableArray<IRecursiveDataEntry>;
	public get selectedItems(): IRecursiveDataEntry[] {
		return this._selectedItems();
	}
	public recursiveChildSelectionStateCss: (item: IRecursiveDataEntry) => string;
	public selectionMode: KnockoutObservable<SelectionMode>;
	private isSelectionOn: KnockoutComputed<boolean>;
	private isMultipleSelectionOn: KnockoutComputed<boolean>;
	public isAllSelected: KnockoutComputed<boolean>;
	private deleteLabel: KnockoutComputed<string>;
	public selectionCountLabel: KnockoutComputed<string>;
	public selectionDeleteCountLabel: KnockoutComputed<string>;

	private _onSelectionToggled: Event<IRecursiveDataEntry[]>;
	public get onSelectionToggled(): IEvent<IRecursiveDataEntry[]> {
		return this._onSelectionToggled;
	}

	public selectionCount: KnockoutComputed<number>;
	private hasIsSelectableFn: boolean;
	private isSelectableFn: (item: IRecursiveDataEntry) => boolean;
	private _notSelectableItems: KnockoutObservableArray<IRecursiveDataEntry>;
	private isSelectable: (item: IRecursiveDataEntry) => boolean;
	private notSelectableItemsCount: KnockoutComputed<number>;

	//paging

	constructor(options?: RecursiveListOptions) {
		this.options = $.extend(
			true,
			{},
			DefaultRecursiveListOptions,
			<RecursiveListOptions>{
				dataSource: {
					filter: {
						bypass: (item: IRecursiveDataEntry) => {
							return this._selectedItems().indexOf(item) >= 0;
						}
					},
					root: null,
					types: null
				}
			},
			options || {}
		);

		this.dataSource = new RecursiveDataSource(this.options.dataSource);
		this.isEmpty = ko.pureComputed(() => this.dataSource.length() <= 0);
		this.viewIsEmpty = ko.pureComputed(() => !this.isEmpty() && this.view().length <= 0);
		this.itemsCountInfo = ko.pureComputed(() => {
			return Localization.Items.concat(': ', this.dataSource.length().toString());
		});

		this._onSelectionToggled = new Event<IRecursiveDataEntry[]>();

		this.idProperty = this.options.idProperty;
		this.properties = this.options.properties
			? this.options.properties.map(property => {
					var defaultRecursiveListPropertyOptions = $.extend(true, {}, property, {
						key: 'entry.' + property.key
					});
					return new this.options.propertyModel(defaultRecursiveListPropertyOptions);
			  })
			: [];

		this.view = this.dataSource.view;

		this.sortSettingStack = {};

		this.clickOnProperty = (property: ListProperty) => {
			this.updateSortSetting(property.nextSortState());
		};

		//#region selection
		this.selectionMode = ko.observable(this.options.selectionMode);
		this.isSelectionOn = ko.pureComputed(() => this.selectionMode() != SelectionMode.NONE);
		this.isMultipleSelectionOn = ko.pureComputed(
			() => this.selectionMode() == SelectionMode.MULTIPLE
		);

		this._selectedItems = ko.observableArray<IRecursiveDataEntry>();
		this.selectionCount = ko.pureComputed(() => this._selectedItems().length);

		this.isAllSelected = ko.pureComputed(() =>
			this.view().every(item => this.isSelected(item) || !this.isSelectable(item))
		);

		// not selectable items
		this.hasIsSelectableFn =
			!_.isUndefined(this.options.isSelectable) && _.isFunction(this.options.isSelectable);
		this.isSelectableFn = this.options.isSelectable;
		this._notSelectableItems = ko.observableArray<IRecursiveDataEntry>();
		this.notSelectableItemsCount = ko.pureComputed(
			() => (this.hasIsSelectableFn ? this._notSelectableItems().length : 0)
		);

		if (this.hasIsSelectableFn) {
			this.dataSource.onDataChanged.subscribe((data: RecursiveDataChangedEvent) => {
				if (this.hasIsSelectableFn) {
					var notSelectableItems = Util.cloneArray(data.data).filter(
						(item: IRecursiveDataEntry) => !this.isSelectableFn(item)
					);
					this._notSelectableItems(notSelectableItems);
				}
			});
		}

		this.isSelectable = (item: IRecursiveDataEntry) => {
			if (this.hasIsSelectableFn) {
				return this._notSelectableItems.indexOf(item) < 0;
			}
			return true;
		};

		//#endregion

		//#region paging
		//this.pagerInputFocus = ko.observable<boolean>(false);
		//this.currentPage = ko.pureComputed(() => this.dataSource.pagingDataMap.currentPage());
		//this.pagingIndexKeyUp = ko.observable<number>(this.currentPage());
		//this.pageCount = ko.pureComputed(() => this.dataSource.pagingDataMap.pageCount());
		//this.isPreviousPageable = ko.pureComputed(() => this.dataSource.pagingDataMap.isPreviousPageable());
		//this.isNextPageable = ko.pureComputed(() => this.dataSource.pagingDataMap.isNextPageable());
		//this.pageSetterVisible = ko.pureComputed(() => this.pageCount() > 10);

		//this.clickFirstPage = () => {
		//    this.dataSource.firstPage();
		//};

		//this.clickPreviousPage = () => {
		//    this.dataSource.previousPage();
		//};

		//this.clickNextPage = () => {
		//    this.dataSource.nextPage();
		//};

		//this.clickLastPage = () => {
		//    this.dataSource.lastPage();
		//};

		//this.clickPage = (page: number) => {
		//    this.dataSource.page(page);
		//};

		//this.currentPage.subscribe((newValue) => {
		//    this.pagingIndexKeyUp(newValue);
		//});

		//this.pagerInputFocus.subscribe((focus) => {
		//    if (!focus) {
		//        this.setPageIndexString();
		//    }
		//});

		//this.setPage = (d: any, e: JQueryKeyEventObject) => {
		//    if (e.keyCode == KeyCode.ENTER) {
		//        this.setPageIndexString();
		//    }
		//}
		//            private setPageIndexString() {
		//    let pageIndex = this.pagingIndexKeyUp();
		//    if ($.isNumeric(pageIndex)) {
		//        this.clickPage(<number>Util.convert(pageIndex, PropertyType.NUMBER));
		//    }
		//}
		//#endregion
	}

	public toggleAllSelection = () => {
		var self = this,
			isAllSelected = this.isAllSelected();

		this.view().forEach(item => this.chainSelection(item, !isAllSelected));
	};
	public toggleSelection = (item: IRecursiveDataEntry) => {
		var selectionMode = this.selectionMode();
		if (
			selectionMode != SelectionMode.NONE &&
			(!this.hasIsSelectableFn || this.isSelectable(item))
		) {
			if (selectionMode == SelectionMode.SINGLE) {
				this._selectedItems.removeAll();
				this._selectedItems.push(item);
			} else {
				this.selectItem(item, !this.isSelected(item));
			}
			//this._onSelectionToggled.notify([item]);
			return true;
		}
		return false;
	};
	public selectItem = (item: IRecursiveDataEntry, selection: boolean) => {
		this.chainSelection(item, selection);
		this.bubbleSelection(item, selection);
	};
	private bubbleSelection = (item: IRecursiveDataEntry, selection: boolean) => {
		if (item.parent) {
			if (selection) {
				if (this.isAllChildSelected(item.parent)) {
					this._selectedItems.push(item.parent);
					this.bubbleSelection(item.parent, selection);
				}
			} else {
				this._selectedItems.remove(item.parent);
				this.bubbleSelection(item.parent, selection);
			}
		}
	};
	private chainSelection = (item: IRecursiveDataEntry, selection: boolean) => {
		if (item && (!this.hasIsSelectableFn || this.isSelectable(item))) {
			if (selection) {
				this._selectedItems.push(item);
			} else {
				this._selectedItems.remove(item);
			}
			Object.keys(item.childEntries).forEach(childKey => {
				item.childEntries[childKey].view().forEach(childItem => {
					this.chainSelection(childItem, selection);
				});
			});
		}
	};
	public isSelected = (item: IRecursiveDataEntry) => {
		return this._selectedItems.indexOf(item) >= 0;
	};
	public recursiveSelectionStateCss = (item: IRecursiveDataEntry) => {
		if (this.isSelected(item)) {
			return IconSet.Ok;
		} else if (this.isSomeChildSelected(item)) {
			return IconSet.SomeChildSelected;
		} else {
			return '';
		}
	};
	public isAllChildSelected = (item: IRecursiveDataEntry): boolean => {
		var self = this;
		return Object.keys(item.childEntries).every(childKey => {
			return item.childEntries[childKey].view().every(childItem => {
				return self.isSelected(childItem);
			});
		});
	};
	public isSomeChildSelected = (item: IRecursiveDataEntry): boolean => {
		var self = this;
		return Object.keys(item.childEntries).some(childKey => {
			return item.childEntries[childKey].view().some(childItem => {
				return self.isSelected(childItem) || self.isSomeChildSelected(childItem);
			});
		});
	};
	public getFirstSelectedChild = (item: IRecursiveDataEntry): IRecursiveDataEntry => {
		var self = this;
		var selectedChild: IRecursiveDataEntry;
		_.find(Object.keys(item.childEntries), childKey => {
			return _.find(item.childEntries[childKey].view(), childItem => {
				if (self.isSelected(childItem)) {
					selectedChild = childItem;
					return true;
				} else if ((selectedChild = self.getFirstSelectedChild(childItem))) {
					return true;
				} else {
					return false;
				}
			});
		});
		return selectedChild;
	};
	public getFirstChild = (item: IRecursiveDataEntry): IRecursiveDataEntry => {
		var self = this;
		var firstChild: IRecursiveDataEntry;
		Object.keys(item.childEntries).some(childKey => {
			var view = item.childEntries[childKey].view();
			if (view && view.length > 0) {
				firstChild = view[0];
				return true;
			} else {
				return false;
			}
		});
		return firstChild;
	};
	public reload(...params: any[]): Promise<RecursiveDataSource> {
		//TODO: block while loading
		//TODO: remember previous selections, UseCase: select 3 - delete 1 -> 2 should stay selected
		this.clearSelection();
		return this.dataSource.reload(...params);
	}
	private updateSortSetting(sortSetting: SortOptions) {
		if (sortSetting.state == SortState.NONE) {
			delete this.sortSettingStack[sortSetting.key];
		} else {
			this.sortSettingStack[sortSetting.key] = sortSetting;
		}
		this.dataSource.sort(_.values(this.sortSettingStack));
	}
	private getItemTemplate(item: IRecursiveDataEntry) {
		if (item && item.type && this.options.typeTemplates && this.options.typeTemplates[item.type]) {
			return this.options.typeTemplates[item.type];
		}
		return '';
	}
	//public selectItem(item: T | string, property: string = this.idProperty): IHierarchyListData<U, T> {
	//    let itemValue: string = _.isString(item) ? <string>item : (<T>item)[property];
	//    return this.selectBy(itemValue, property);
	//}
	//public selectBy(value: any, property: string = this.idProperty): IHierarchyListData<U, T> {
	//    let selectItem: IHierarchyListData<U, T> = _.find(this.dataSource.data(), dataItem => dataItem[property] == value);
	//    if (selectItem) {
	//        if (this.toggleSelection(selectItem)) {
	//            return selectItem;
	//        }
	//    }
	//    return undefined;
	//}
	//public selectItems(items: T[] | string[], property: string = this.idProperty) {
	//    if (this.selectionMode() == SelectionMode.MULTIPLE && _.isArray(items) && items.length > 0) {
	//        var itemValues: string[] = _.isString(items[0]) ? <string[]>items : (<T[]>items).map(item => <string>item[property]);
	//        var data = this.dataSource.data(),
	//            length = data.length;
	//        for (let i = 0; i < length; i++) {
	//            if (Util.containsRemove(itemValues, data[i][property])) {
	//                this._selectedItems.push(data[i]);
	//                //no more to select, break loop
	//                if (itemValues.length == 0) {
	//                    i = length;
	//                }
	//            }
	//        }
	//        this._onSelectionToggled.notify(this._selectedItems());
	//    }
	//}
	public clearSelection(): void {
		this._selectedItems.removeAll();
	}
}
